import React, {memo} from 'react';
import {Node} from "rete-react-render-plugin";
import {NODE_LABEL_DEFAULT_COLOR} from "../stylingConstants";
import {validate as uuidValidate} from "uuid";
import {EndComponent} from "../components";
import Input from "./components/Input";
import styled from '@emotion/styled';

const StyledNodeDiv = styled.div`
  width: auto;
  background: rgba(255, 255, 255, 0.8);
  border: ${props => props.$selected ? "1px solid #000000" : "none"};
  box-shadow: 0px 2px 10px -4px rgba(0, 0, 0, 0.6);
  border-radius: 15px;
  cursor: pointer;
  min-width: 180px;
  height: auto;
  padding-bottom: 0px;
  position: relative;
  user-select: none;
  box-sizing: border-box;
`;

const StyledHeaderDiv = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 8px 24px 8px 0px;
  border-radius: 15px;
  gap: 16px;
  background-color: ${NODE_LABEL_DEFAULT_COLOR};
`;

const StyledFlexContainerDiv = styled.div`
  display: flex;
  flex: 1;
  align-self: stretch;
  margin-left: 8px;
`;

const StyledNodeNameDiv = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  font-size: 1.125rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export class EndNode extends Node {
    render() {
        return <End {...this.props} {...this.state} />
    }
}

const End = memo((props) => {

    const {node, bindSocket, inputs, selected} = props;

    let endNodeInput = null;
    if (inputs !== undefined) {
        inputs.forEach(input => {
            const inputKey = input.key.split('_');
            if (!uuidValidate(inputKey[0])) {
                throw new Error('input key format is not valid!');
            }
            switch(inputKey[1]) {
                case EndComponent.END_COMPONENT_KEY:
                    if (endNodeInput) throw new Error("EndNode cannot handle multiple inputs.");
                    endNodeInput = input;
                    break;
                default:
                    console.error(`Component '${inputKey[1]}' does not have 'Input' handling!`);
                    break;
            }
        });
    }

    // TODO: create styled class eg Node for Start, End, Sequence (same styling)
    return (
        <StyledNodeDiv className="node" $selected={selected}>
            <StyledHeaderDiv>
                {/** Node Input */}
                <Input
                    input={endNodeInput}
                    bindSocket={bindSocket}
                />

                <StyledFlexContainerDiv>
                    <StyledNodeNameDiv>
                        {node.name}
                    </StyledNodeNameDiv>
                </StyledFlexContainerDiv>
            </StyledHeaderDiv>
        </StyledNodeDiv>
    );
});